import { isCreativeFabricaEmail } from '@repo/studio-utils/email'
import { useUserQuery } from 'auth/hooks'

export function useIsAdminQuery() {
  return useUserQuery(undefined, {
    select: data => isCreativeFabricaEmail(data?.me?.user?.email),
  })
}
